// Machine-translated and AI-written copy is full of U+2011 NON-BREAKING HYPHEN, and most
// web-font subsets have no glyph for it (Albert Sans's latin subset among them). The engine
// then borrows one from a fallback font — a different-looking hyphen at best, and on Chrome
// 64 and 105 a missing-glyph box. The plain hyphen is in every font; the line may now wrap
// after it.
const NON_BREAKING_HYPHEN = /‑/g

/**
 * The translations with every U+2011 in their TipTap text swapped for `-`. The input is never
 * written to (the preview's copy may be shared), so only changed entries are new objects.
 */
export function withPlainHyphens<T extends Record<string, unknown>>(translations: T): T {
  let swapped: Record<string, unknown> | undefined
  for (const [key, value] of Object.entries(translations)) {
    const next = swap(value)
    if (next !== value) (swapped ??= { ...translations })[key] = next
  }
  return (swapped ?? translations) as T
}

function swap(node: unknown): unknown {
  if (typeof node === 'string') {
    return node.includes('‑') ? node.replace(NON_BREAKING_HYPHEN, '-') : node
  }
  if (Array.isArray(node)) {
    let copy: unknown[] | undefined
    node.forEach((child, i) => {
      const next = swap(child)
      if (next !== child) (copy ??= node.slice())[i] = next
    })
    return copy ?? node
  }
  if (!node || typeof node !== 'object') return node
  const { text, content } = node as { text?: unknown; content?: unknown }
  const nextText = typeof text === 'string' ? swap(text) : text
  const nextContent = Array.isArray(content) ? swap(content) : content
  if (nextText === text && nextContent === content) return node
  const copy: Record<string, unknown> = { ...node }
  if (nextText !== text) copy.text = nextText
  if (nextContent !== content) copy.content = nextContent
  return copy
}
